import React from 'react';
import About from '../containers/About/About';
import Footer from '../containers/Footer/Footer';

const AboutPage = () => {
  return (
    <div>
      <About />
      <Footer />
    </div>
  );
};

export default AboutPage;
